// extracted by mini-css-extract-plugin
export default {"backgroundImage":"TransferComponent_backgroundImage__M-5hh","arrowImage":"TransferComponent_arrowImage__s5SIK","text":"TransferComponent_text__QTJ+Y"};